
import PropTypes from 'prop-types';
import { ActionOperatorEnum, AttributionModelTypeEnum, CategoryOperatorEnum, ConversionCountTypeEnum, GOAL_CATEGORY, GoalStatusEnum, GoalValueTypeEnum, LabelOperatorEnum, ValueOperatorEnum } from '@bingads-webui-campaign-react/goal-creation-shared-config';

export const GoalPropType = {
  Selected: PropTypes.bool,
  GoalId: PropTypes.number,
  GoalCategory: PropTypes.oneOf(Object.values(GOAL_CATEGORY)),
  Type: PropTypes.string,
  CurrencyCode: PropTypes.string,
  GoalValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  IsAccountLevel: PropTypes.bool,
  ConversionCountType: PropTypes.oneOf(ConversionCountTypeEnum),
  IsMainConversionGoal: PropTypes.bool,
  LookbackWindowInMinutes: PropTypes.number,
  LookbackWindowinStr: PropTypes.string,
  ViewThroughLookbackWindowinMinutes: PropTypes.number,
  ViewThroughLookbackWindowinStr: PropTypes.string,
  ActionOperator: PropTypes.oneOf(ActionOperatorEnum),
  Action: PropTypes.string,
  ValueOperator: PropTypes.oneOf(ValueOperatorEnum),
  Value: PropTypes.number,
  LabelOperator: PropTypes.oneOf(LabelOperatorEnum),
  Label: PropTypes.string,
  CategoryOperator: PropTypes.oneOf(CategoryOperatorEnum),
  Category: PropTypes.string,
  Status: PropTypes.oneOf(GoalStatusEnum),
  AttributionModelType: PropTypes.oneOf(AttributionModelTypeEnum),
  Name: PropTypes.string,
  GoalValueType: PropTypes.oneOf(GoalValueTypeEnum),
  Tag: PropTypes.shape({
    Id: PropTypes.number,
  }),
  IsEnhancedConversionsEnabled: PropTypes.bool,
  '@odata.type': PropTypes.string,
};
